// autotuneIcons — central mapping from topic icon names returned by the
// backend (`student_autotune_routes.TOPIC_CATALOG`) to actual lucide-react
// components. Keeps every chip across MagicDesk/Narrate/Deskeynomics on the
// same visual language without us having to ship PNGs.
import {
  Trophy, Goal, Dribbble, CircleDot, Footprints, PersonStanding, Crown,
  Code2, Gamepad2, Bot, BrainCircuit, Boxes,
  Rocket, Telescope, Bone, CloudSun,
  PawPrint, Bird, Waves, TreePine,
  Sparkles, Film, Music2, Palette, Zap, BookOpen,
  Landmark, Plane, Globe2, Vote,
  ChefHat, Cookie,
  Car, PlaneTakeoff,
  Briefcase, TrendingUp,
  Compass,    // fallback
} from 'lucide-react';

const REGISTRY = {
  Trophy, Goal, Dribbble, CircleDot, Footprints, PersonStanding, Crown,
  Code2, Gamepad2, Bot, BrainCircuit, Boxes,
  Rocket, Telescope, Bone, CloudSun,
  PawPrint, Bird, Waves, TreePine,
  Sparkles, Film, Music2, Palette, Zap, BookOpen,
  Landmark, Plane, Globe2, Vote,
  ChefHat, Cookie,
  Car, PlaneTakeoff,
  Briefcase, TrendingUp,
};

export function topicIcon(name) {
  return REGISTRY[name] || Compass;
}

// Per-category accent — feeds the chip gradients so e.g. all Sports chips
// share a vibrant warm tone, all Tech chips lean blue/purple, etc. Keeps the
// chip wall feeling coherent even when packed with many topics.
export const CATEGORY_ACCENT = {
  sports:   { from: '#F97316', to: '#DC2626' },     // orange → red
  tech:     { from: '#6366F1', to: '#8B5CF6' },     // indigo → violet
  science:  { from: '#0EA5E9', to: '#06B6D4' },     // sky → cyan
  nature:   { from: '#10B981', to: '#059669' },     // emerald
  arts:     { from: '#EC4899', to: '#F43F5E' },     // pink → rose
  world:    { from: '#F59E0B', to: '#D97706' },     // amber
  food:     { from: '#FB923C', to: '#EF4444' },     // peach → red
  vehicles: { from: '#475569', to: '#1E293B' },     // slate
  money:    { from: '#059669', to: '#0F766E' },     // teal
};

export function categoryAccent(cat) {
  return CATEGORY_ACCENT[cat] || { from: '#64748B', to: '#334155' };
}
